var sanitizeEmojiValue = function sanitizeEmojiValue(value) {
  return value && value.replace(/['"]+/g, '').replace(/null/, '') || '';
};
export var extractTitlePrefix = function extractTitlePrefix(jsonLd, renderers, type) {
  var prefix = jsonLd['atlassian:titlePrefix'];
  if (prefix) {
    // extract and return Emoji Title Prefix
    if (prefix['@type'] === 'atlassian:Emoji') {
      var emojiId = sanitizeEmojiValue(prefix['text']);
      var hasEmojiPrefix = emojiId.length !== 0;
      var emojiRenderer = renderers === null || renderers === void 0 ? void 0 : renderers.emoji;
      if (hasEmojiPrefix && emojiRenderer) {
        return emojiRenderer(emojiId, type);
      }
    }
  }
  return undefined;
};